// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1xwt_","label":"Section_label__3Kxr_","contentWrap":"Section_contentWrap__1DEUd","footer":"Section_footer__3bgZS","footerInner":"Section_footerInner__OtOAF"};